import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import './FeaturedPackages.css';

/* Fallback static data (used only if Supabase has 0 active packages) */
const STATIC_PACKAGES = [
    { id: 1, destination: 'Vietnam', duration: '7 Days / 6 Nights', price: '74,000', image_url: 'https://images.unsplash.com/photo-1528127269322-539801943592?q=80&w=800&auto=format&fit=crop', tag: 'Most Loved', size: 'large', itinerary_slug: 'Vietnam' },
    { id: 2, destination: 'Kerala Tour Packages', duration: '5 Days / 4 Nights', price: '30,000', image_url: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?q=80&w=800&auto=format&fit=crop', size: 'small', itinerary_slug: 'Kerala' },
    { id: 3, destination: 'Bali', duration: '6 Days / 5 Nights', price: '62,800', image_url: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?q=80&w=800&auto=format&fit=crop', size: 'small', itinerary_slug: 'Bali' },
    { id: 4, destination: 'Thailand', duration: '5 Days / 4 Nights', price: '35,200', image_url: 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?q=80&w=800&auto=format&fit=crop', size: 'small', itinerary_slug: 'Thailand' },
    { id: 5, destination: 'Maldives', duration: '5 Days / 4 Nights', price: '90,000', image_url: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTl8CXel4YPwCi08UTsP4XAlckXu_NyqmZ9dw&s', size: 'small', itinerary_slug: 'Maldives' },
    { id: 6, destination: 'Dubai', duration: '5 Days / 4 Nights', price: '1,00,000', image_url: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?q=80&w=800&auto=format&fit=crop', size: 'small', itinerary_slug: 'Dubai' },
    { id: 7, destination: 'Sri Lanka', duration: '6 Days / 5 Nights', price: '60,700', image_url: 'https://images.unsplash.com/photo-1546708973-b339540b5162?q=80&w=800&auto=format&fit=crop', size: 'small', itinerary_slug: 'Sri Lanka' },
];

const FeaturedPackages = () => {
    const [packages, setPackages] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPackages = async () => {
            const { data, error } = await supabase
                .from('featured_packages')
                .select('*')
                .eq('active', true)
                .order('display_order', { ascending: true });
            if (!error && data && data.length > 0) setPackages(data);
            else setPackages(STATIC_PACKAGES);
        };
        fetchPackages();
    }, []);

    const openItinerary = (slug) => {
        if (slug) navigate(`/itinerary/${encodeURIComponent(slug)}`);
    };

    return (
        <section className="packages-section" id="holidays">
            <div className="packages-container">
                <div className="packages-header">
                    <div className="header-left">
                        <span className="sub-heading">Adventure Awaits</span>
                        <h2 className="main-heading">Featured Packages</h2>
                    </div>
                    <button className="view-all-btn" onClick={() => navigate('/packages')}>View All Destinations</button>
                </div>

                <div className="packages-grid">
                    {packages.map((pkg) => (
                        <div
                            key={pkg.id}
                            className={`package-card ${pkg.size}`}
                            style={{ backgroundImage: `url(${pkg.image_url})` }}
                        >
                            <div className="package-overlay"></div>

                            {pkg.tag && <span className="package-tag">{pkg.tag}</span>}

                            <div className="package-content">
                                <div className="package-info">
                                    <h3 className="pkg-destination">{pkg.destination}</h3>
                                    <p className="pkg-duration">
                                        <i className="fa-regular fa-clock"></i> {pkg.duration}
                                    </p>
                                </div>

                                <div className="package-footer">
                                    <div className="price-box">
                                        <span className="price-label">Starting Price</span>
                                        <span className="price-amount">₹{pkg.price}</span>
                                    </div>
                                    <button className="view-details-btn" onClick={() => openItinerary(pkg.itinerary_slug)}>
                                        View Details
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturedPackages;

